import { apiClient } from "./httpClient";
import { unwrapEnvelope, unwrapList, unwrapMeta } from "./response";

export const financeApi = {
  async getDashboard(params = {}) {
    const response = await apiClient.get("/finance/dashboard", { params });
    return unwrapEnvelope(response.data, {});
  },

  async getReports(params = {}) {
    const response = await apiClient.get("/finance/reports", { params });
    return unwrapEnvelope(response.data, {});
  },

  async listInvoices(params = {}) {
    const response = await apiClient.get("/invoices", { params });
    return {
      data: unwrapList(response.data),
      meta: unwrapMeta(response.data)
    };
  },

  async getInvoice(id) {
    const response = await apiClient.get(`/invoices/${id}`);
    return unwrapEnvelope(response.data, null);
  },

  async createInvoice(payload) {
    const response = await apiClient.post("/invoices", payload);
    return unwrapEnvelope(response.data, null);
  },

  async updateInvoice(id, payload) {
    const response = await apiClient.patch(`/invoices/${id}`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async listPayments(params = {}) {
    const response = await apiClient.get("/payments", { params });
    return {
      data: unwrapList(response.data),
      meta: unwrapMeta(response.data)
    };
  },

  async getPayment(id) {
    const response = await apiClient.get(`/payments/${id}`);
    return unwrapEnvelope(response.data, null);
  },

  async recordPayment(payload) {
    const response = await apiClient.post("/payments", payload);
    return unwrapEnvelope(response.data, null);
  },

  async refundPayment(id, payload) {
    const response = await apiClient.post(`/payments/${id}/refund`, payload);
    return unwrapEnvelope(response.data, null);
  }
};
